import type {
    CrmFilterKey,
    CrmFilterKeyPrefix,
} from "app/pages/sales-intelligence/domain/crm-integration/types/crm-filter-key";
import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import type { CrmIntegrationProvider } from "../types/provider";

// A condition's identity is (field, inclusion side) — Include lives under the bare field key,
// Exclude under its `:$exclude` variant, so both sides of one field coexist in the flat panel map. The `:$`
// suffix namespace is panel-internal and reserved — it never reaches the wire (the DTO adapter strips it).
const EXCLUDE_SUFFIX = ":$exclude";

export const crmFilterKeyPrefix = (provider: CrmIntegrationProvider): CrmFilterKeyPrefix => `crm:${provider}:`;

export const toCrmFilterKey = (provider: CrmIntegrationProvider, fieldKey: string): CrmFilterKey =>
    `${crmFilterKeyPrefix(provider)}${fieldKey}`;

export const isCrmFieldKey = (provider: CrmIntegrationProvider, key: string): boolean =>
    key.startsWith(crmFilterKeyPrefix(provider));

const isExcludeConditionKey = (key: string): boolean => key.endsWith(EXCLUDE_SUFFIX);

const excludeConditionKey = (fieldValueKey: string): string => `${bareCrmConditionKey(fieldValueKey)}${EXCLUDE_SUFFIX}`;

/** The inclusion side a condition key encodes. */
export const crmConditionInclusion = (key: string): InclusionOption =>
    isExcludeConditionKey(key) ? inclusionOptionMap.excludeOnly : inclusionOptionMap.includeOnly;

export const bareCrmConditionKey = (key: string): string =>
    isExcludeConditionKey(key) ? key.slice(0, -EXCLUDE_SUFFIX.length) : key;

/** The condition key capturing the given inclusion side of the same field (idempotent either way). */
export const crmConditionVariantKey = (key: string, inclusion: InclusionOption): string =>
    inclusion === inclusionOptionMap.excludeOnly ? excludeConditionKey(key) : bareCrmConditionKey(key);
